module.exports = __webpack_public_path__ + "img/icon_safe.85430a5b.png";